import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-search-eye-line',
    title: 'Discover Products',
    desc: 'Browse organized category spreadsheets to find shoes, clothing, accessories and more across 14 curated categories.',
    link: '/article/superbuy-sheet-complete-guide',
    linkText: 'Learn More',
    isInternal: true,
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Compare & Save',
    desc: 'Compare products side by side with organized data. Make informed decisions and find the best value for your budget.',
    link: '/article/superbuy-sheet-vs-manual-browsing',
    linkText: 'Compare Methods',
    isInternal: true,
  },
  {
    icon: 'ri-book-open-line',
    title: 'Expert Guides',
    desc: 'Access in-depth shopping guides, safety tips, and tutorials written by experienced researchers and shopping experts.',
    link: '/article/superbuy-sheet-beginner-tutorial',
    linkText: 'Start Learning',
    isInternal: true,
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: 'Shop Directly',
    desc: 'Ready to shop? Jump straight to the main Superbuy Sheet platform and explore all available products instantly.',
    link: 'https://kaspreadsheet.com',
    linkText: 'superbuy sheet',
    isInternal: false,
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider rounded-full border border-background-300/60">
            Why Choose Us
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 tracking-tight leading-tight">
            Everything You Need For{' '}
            <span className="text-accent-600">Smarter Shopping</span>
          </h2>
          <p className="mt-4 text-foreground-500 text-base max-w-xl mx-auto">
            Superbuy Sheet brings together discovery, comparison, learning, and direct shopping in one organized experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:bg-accent-100/70 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-xl text-secondary-600 group-hover:text-accent-700 transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-foreground-950">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-5 group-hover:text-foreground-600">
                {feat.desc}
              </p>
              {feat.isInternal ? (
                <Link
                  to={feat.link}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 text-xs font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {feat.linkText}
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              ) : (
                <a
                  href={feat.link}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 text-xs font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {feat.linkText}
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}